import { Typography } from 'antd';
import './SpeedChartComponent.scss';
import { ChartData } from 'chart.js';
import { Chart } from 'react-chartjs-2';
import 'chartjs-adapter-luxon';
import { DataTelemetry } from '../../../../gen/proto/api/gateway/v1/gateway_pb';
import { DataTelemetryData } from '../../../../models/telemetry';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { colors } from '../../../../theme/colors';

const { Title } = Typography;

interface SpeedChartComponentProps {
  data: DataTelemetry[];
}

function buildSpeedChartData(telemetries: DataTelemetry[]): ChartData<'line'> {
  if (!telemetries || telemetries.length === 0) {
    return { labels: [], datasets: [] };
  }

  const sorted = [...telemetries].sort((a, b) => Number(a.timestamp?.seconds ?? 0) - Number(b.timestamp?.seconds ?? 0));

  const labels: string[] = [];
  const speed1: number[] = [];
  const speed2: number[] = [];

  for (const t of sorted) {
    const seconds = Number(t.timestamp?.seconds ?? 0);
    const date = DateTime.fromMillis(seconds * 1000).toISO();
    const telemetryData = t.data as DataTelemetryData;

    labels.push(date || '');
    speed1.push(telemetryData?.command?.command_speed_1?.value ?? 0);
    speed2.push(telemetryData?.command?.command_speed_2?.value ?? 0);
  }

  return {
    labels,
    datasets: [
      {
        label: 'Velocidad 1',
        data: speed1,
        borderColor: colors.PRIMARY_HOVER,
        backgroundColor: colors.PRIMARY_HOVER,
        fill: false,
        tension: 0,
        pointRadius: 0,
      },
      {
        label: 'Velocidad 2',
        data: speed2,
        borderColor: colors.SECONDARY,
        backgroundColor: colors.SECONDARY,
        fill: false,
        tension: 0,
        pointRadius: 0,
      },
    ],
  };
}

const SpeedChartComponent = ({ data }: SpeedChartComponentProps) => {
  const chartData = useMemo(() => buildSpeedChartData(data || []), [data]);

  return (
    <div className="SpeedChartComponent">
      <Title level={4} className={'SpeedChartComponent__title'}>
        Velocidades históricas
      </Title>
      <Chart
        type="line"
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            legend: {
              position: 'top' as const,
            },
            title: {
              display: false,
            },
            zoom: {
              zoom: {
                wheel: {
                  enabled: true,
                },
                pinch: {
                  enabled: true,
                },
                mode: 'x',
              },
              limits: {
                x: { min: 'original', max: 'original' },
                y: { min: 'original', max: 'original' },
              },
              pan: {
                enabled: true,
                mode: 'x',
              },
            },
          },

          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'minute',
              },
              title: {
                display: true,
                text: 'Tiempo',
              },
            },
            y: {
              beginAtZero: true,
              max: 100,
              title: {
                display: true,
                text: 'Velocidad (%)',
              },
            },
          },
        }}
      />
    </div>
  );
};

export default SpeedChartComponent;
